import type { AlertPreferenceKey, AlertPreferences, WeatherAlert } from "./types";

export const DEFAULT_ALERT_PREFERENCES: AlertPreferences = {
  greenheads: true,
  weather: true,
  lightning: true,
  marine: true
};

export function normalizeAlertPreferences(input?: Partial<AlertPreferences> | null): AlertPreferences {
  return {
    greenheads: input?.greenheads ?? DEFAULT_ALERT_PREFERENCES.greenheads,
    weather: input?.weather ?? DEFAULT_ALERT_PREFERENCES.weather,
    lightning: input?.lightning ?? DEFAULT_ALERT_PREFERENCES.lightning,
    marine: input?.marine ?? DEFAULT_ALERT_PREFERENCES.marine
  };
}

export function preferenceForWeatherAlert(alert: WeatherAlert): AlertPreferenceKey {
  const text = `${alert.event} ${alert.headline} ${alert.description || ""}`.toLowerCase();
  if (/(lightning|thunderstorm|severe thunderstorm)/.test(text)) return "lightning";
  if (/(marine|small craft|rip current|high surf|beach hazard|coastal flood|coastal waters|surf zone)/.test(text)) return "marine";
  return "weather";
}
